import React from 'react'
import { Link } from 'react-router-dom';
import { Image, Spin } from 'antd';
import BlurredPlaceHolder from '../../assets/images/blurred-placeholder.png'
import useNFTPrice from '../../hooks/useNFTPrice';
import NumberFormat from 'react-number-format';
import useNFTSoldStatus from '../../hooks/useNFTSoldStatus';
export default function SingleNft(props) {

    const { data } = props
    const { isLoading: nftPriceLoading, nftPrice } = useNFTPrice({ category: data?.type })
    const { isSold } = useNFTSoldStatus({ tokenID: data?.id })

    const getImageURL = (data) => {
        if (data) {
            const ipfsURL = data.image
            return ipfsURL.replace("ipfs://", "https://h4g.mypinata.cloud/ipfs/")
        } else {
            return null
        }
    }

    return (
        <div>
            <div className="nft__item">
                <div className="nft_type">
                    <span style={{ textTransform: 'uppercase', fontWeight: '600' }} >{data ? data.type : ''}</span>
                </div>

                <div className='nft-clickable-container '>
                    {
                        isSold ? (<Link to={`/buy-nft/${data.id}`}>
                            <div className="author_list_pp">
                                <span>
                                    <i className="fa fa-check"></i>
                                </span>
                            </div>
                            <div className="nft__item_wrap" >
                                <span>
                                    <Image
                                        preview={false}
                                        src={data ? getImageURL(data) : null}
                                        className="lazy nft__item_preview"
                                        placeholder={
                                            <Image
                                                className="lazy nft__item_preview"
                                                preview={false}
                                                src={BlurredPlaceHolder}
                                            />
                                        }
                                    />
                                </span>
                            </div>
                            <div className="nft__item_info">
                                <span>
                                    <h5>{data ? data.name : ''}</h5>
                                    <span className='nft__item_price'>Token ID : # {data ? data.id : ''}</span>
                                </span>

                                <div className="nft__item_price">
                                    {
                                        nftPriceLoading ? (
                                            <div className='d-flex'>
                                                <Spin size='small' />
                                            </div>
                                        ) : (
                                            <>
                                                <NumberFormat
                                                    value={nftPrice ? nftPrice : 0.00}
                                                    displayType="text"
                                                    suffix=' BUSD'
                                                    decimalScale={4}
                                                    thousandSeparator={true}
                                                />
                                            </>
                                        )
                                    }
                                </div>
                                <div className="list-nft-btn mb-3">
                                    <span>View Details</span>
                                </div>
                            </div>
                        </Link>) : (
                            <Link to={`/buy-nft/${data.id}`}>
                                <div className="author_list_pp">
                                    <span>
                                        <i className="fa fa-check"></i>
                                    </span>
                                </div>
                                <div className="nft__item_wrap" >
                                    <span>
                                        <Image
                                            preview={false}
                                            src={data ? getImageURL(data) : null}
                                            className="lazy nft__item_preview"
                                            placeholder={
                                                <Image
                                                    className="lazy nft__item_preview"
                                                    preview={false}
                                                    src={BlurredPlaceHolder}
                                                />
                                            }
                                        />
                                    </span>
                                </div>
                                <div className="nft__item_info">
                                    <span>
                                        <h5>{data ? data.name : ''}</h5>
                                        <span className='nft__item_price'>Token ID : # {data ? data.id : ''}</span>
                                    </span>

                                    <div className="nft__item_price">
                                        {
                                            nftPriceLoading ? (
                                                <div className='d-flex'>
                                                    <Spin size='small' />
                                                </div>
                                            ) : (
                                                <>
                                                    <NumberFormat
                                                        value={nftPrice ? nftPrice : 0.00}
                                                        displayType="text"
                                                        suffix=' BUSD'
                                                        decimalScale={4}
                                                        thousandSeparator={true}
                                                    />
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className="list-nft-btn mb-3">
                                        <span>Buy NFT</span>
                                    </div>
                                </div>
                            </Link>
                        )
                    }

                </div>

                {
                    isSold ? (
                        <div class="ribbon-wrapper-green"><div class="ribbon-green">SOLD</div></div>
                    ) : (
                        <></>
                    )
                }
            </div>
        </div>
    )
}